import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DocRouteService {

  urlDocsObservable: EventEmitter<string> = new EventEmitter()

  constructor() { }

  emitUrl(url: string) {
    this.urlDocsObservable.emit(url)
  }
}
